import script from "./LiveBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveBoard.vue?vue&type=script&setup=true&lang=js"

import "./LiveBoard.vue?vue&type=style&index=0&id=ee185b60&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee185b60"]])

export default __exports__